// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import { addToChainAfter, addToChainBefore } from "@insite/client-framework/HandlerCreator";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import {
    chain,
    DispatchBeginLoadCart,
    DispatchCompleteLoadCart,
    PopulateApiParameter,
    SetNeedFullCart,
} from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import { getCurrentPage, getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import updateCart from "@mcmc/App/Handlers/CommonHandlers/UpdateCart";

type HandlerType = Parameters<typeof PopulateApiParameter>[0];

export const CustomSetNeedFullCart = (props: HandlerType) => {
    const pageType = getCurrentPage(props.getState()).type;
    props.needFullCart = props.needFullCart || pageType === "CheckoutShippingPage";
};

// MCMC-1833, MCMC-1835: add "onCanceled" callback when chain cancelled
export const XngDispatchBeginLoadCart = (props: HandlerType) => {
    if (getCurrentCartState(props.getState()).isLoading) {
        (props.parameter as any).onCanceled?.();
    }
};

export const IncludeCartLines = (props: HandlerType) => {
    const pageType = getCurrentPage(props.getState()).type;
    const shouldAppendMiniCartExpands =
        !props.parameter.shouldLoadFullCart &&
        !(
            pageType === "CheckoutShippingPage" ||
            pageType === "CheckoutReviewAndSubmitPage" ||
            pageType === "CartPage" ||
            pageType === "OnePageCheckoutPage" ||
            pageType === "RfqRequestQuotePage"
        );
    if (!props.needFullCart && shouldAppendMiniCartExpands) {
        const expands = (props.apiParameter.expand || []).concat(["cartLines", "restrictions", "hiddenproducts"]);
        props.apiParameter.expand = [...new Set(expands)] as typeof props.apiParameter.expand;
    }
};

export const PreventCacheForRockwellCart = (props: HandlerType) => {
    const location = getLocation(props.getState());
    const rockwellSuccess = parseQueryString<{ rockwellSuccess?: string }>(location.search).rockwellSuccess;
    if (rockwellSuccess) {
        (props.apiParameter as any).epoch = new Date().getTime();
    }
};

export const UpdateCart = (props: HandlerType) => {
    const location = getLocation(props.getState());
    const rockwellSuccess = parseQueryString<{ rockwellSuccess?: string }>(location.search).rockwellSuccess;
    if (rockwellSuccess) {
        props.dispatch(updateCart({ cart: props.apiResult.cart }));
    }
};

addToChainBefore(chain, DispatchBeginLoadCart, XngDispatchBeginLoadCart);
addToChainAfter(chain, SetNeedFullCart, CustomSetNeedFullCart);
addToChainAfter(chain, PopulateApiParameter, IncludeCartLines);
addToChainAfter(chain, IncludeCartLines, PreventCacheForRockwellCart);
addToChainAfter(chain, DispatchCompleteLoadCart, UpdateCart);
